export { default } from './Hero';
export { default as adapter } from './adapter';
